// extracted by mini-css-extract-plugin
export var colored = "join-module--colored--4WRVY";
export var content = "join-module--content--tQ6qY";
export var blue = "join-module--blue--3p6fH";
export var purple = "join-module--purple--tTUCk";
export var title = "join-module--title--BwckB";
export var description = "join-module--description--jPXoQ";
export var postscript = "join-module--postscript--wFkpc";
export var button = "join-module--button--1OBAM";
export var transparent = "join-module--transparent--LHW+M";